import { REITH_SANS, REITH_SERIF } from '../fontFamilies';

const reith = {
  sans: {
    regular: {
      fontFamily: REITH_SANS,
      fontStyle: 'normal',
      fontWeight: 400,
    },
    regularItalic: {
      fontFamily: REITH_SANS,
      fontStyle: 'italic',
      fontWeight: 400,
    },
    bold: {
      fontFamily: REITH_SANS,
      fontStyle: 'normal',
      fontWeight: 700,
    },
    boldItalic: {
      fontFamily: REITH_SANS,
      fontStyle: 'italic',
      fontWeight: 700,
    },
    light: {
      fontFamily: REITH_SANS,
      fontStyle: 'normal',
      fontWeight: 300,
    },
  },
  serif: {
    regular: {
      fontFamily: REITH_SERIF,
      fontStyle: 'normal',
      fontWeight: 400,
    },
    medium: {
      fontFamily: REITH_SERIF,
      fontStyle: 'normal',
      fontWeight: 500,
    },
    mediumItalic: {
      fontFamily: REITH_SERIF,
      fontStyle: 'italic',
      fontWeight: 500,
    },
    bold: {
      fontFamily: REITH_SERIF,
      fontStyle: 'normal',
      fontWeight: 700,
    },
    light: {
      fontFamily: REITH_SERIF,
      fontStyle: 'normal',
      fontWeight: 300,
    },
  },
};

export default reith;
